const LOCAL_KEY = 'token';
const SESSION_KEY = 'token_session';

export const getAuthToken = function () {
    return localStorage.getItem(LOCAL_KEY) || sessionStorage.getItem(SESSION_KEY) || null;
};

export const setAuthToken = function (token, remember) {
    if (!token) {
        return;
    }
    if (remember) {
        localStorage.setItem(LOCAL_KEY, token);
        sessionStorage.removeItem(SESSION_KEY);
        return;
    }
    sessionStorage.setItem(SESSION_KEY, token);
    localStorage.removeItem(LOCAL_KEY);
};

export const clearAuthToken = function () {
    localStorage.removeItem(LOCAL_KEY);
    sessionStorage.removeItem(SESSION_KEY);
};

